import React from 'react';
import { IoIosCheckmark } from 'react-icons/io';

import { BubbleAvatar } from '../common/bubble-avatar.ui';

import { Message } from '@/slw/entities/chat';
import { useChatStore } from '@/slw/shared/lib/firebase/chat-store';
import { useMessageSeenStatus } from '@/slw/features/chat';

export function MessageSeenIndicator({
  chatId,
  currentUserId,
  message,
  className,
}: {
  message: Message;
  chatId: string | null;
  currentUserId: string;
  className?: string;
}) {
  const { isMyLastMessage, isSeen, loading, error } = useMessageSeenStatus(chatId, message.id, currentUserId);

  const { user } = useChatStore();

  if (!isMyLastMessage || loading || error) {
    return null;
  }

  return (
    <div>
      {isMyLastMessage && (
        <div className={`seen-indicator mt-0.5  text-gray-500 ${isSeen ? 'seen' : 'sent'}, ${className}`}>
          {isSeen ? (
            <BubbleAvatar size='xs' src={user?.avatar} name={user?.username || ''} />
          ) : (
            <span className='flex items-center text-xs'>
              <IoIosCheckmark size={16} /> Sent
            </span>
          )}
        </div>
      )}
    </div>
  );
}
